export class ImosDarkmode extends HTMLElement {
  private on = false;

  connectedCallback(): void {
    this.on = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.apply();

    this.addEventListener('click', () => this.toggle());
  }

  private toggle(): void {
    this.on = !this.on;
    this.apply();
  }

  private apply(): void {
    document.documentElement.classList.toggle('dark', this.on);

    const showWhenOff = this.querySelector('[data-darkmode="off"]');
    const showWhenOn = this.querySelector('[data-darkmode="on"]');

    if (showWhenOff) {
      (showWhenOff as HTMLElement).style.display = this.on ? 'none' : '';
    }
    if (showWhenOn) {
      (showWhenOn as HTMLElement).style.display = this.on ? '' : 'none';
    }
  }
}

customElements.define('imos-darkmode', ImosDarkmode);
